import { createRouter, createWebHashHistory } from 'vue-router';
import { authStore } from '../store/auth';

import LandingPage from '../views/LandingPage.vue';
import LoginPage from '../views/LoginPage.vue';
import DashboardPage from '../views/DashboardPage.vue';
import ApplicationViewA from '../views/ApplicationViewA.vue';
import ApplicationViewB from '../views/ApplicationViewB.vue';
import ApplicationViewC from '../views/ApplicationViewC.vue';
import AdminLayout from '../views/AdminLayout.vue';
import AdminWorkflowConfigPage from '../views/AdminWorkflowConfigPage.vue';
import AdminFormIQ3Page from '../views/AdminFormIQ3Page.vue';
import CaseworkerReviewPage from '../views/CaseworkerReviewPage.vue';

const routes = [
  { path: '/', component: LandingPage },
  { path: '/login', component: LoginPage },
  {
    path: '/dashboard',
    component: DashboardPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/application/literature',
    component: ApplicationViewA,
    meta: { requiresAuth: true },
  },
  {
    path: '/application/naturalization',
    component: ApplicationViewB,
    meta: { requiresAuth: true },
  },
  {
    path: '/application/tree-protection/:caseId?',
    component: ApplicationViewC,
    meta: { requiresAuth: true },
  },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/formiq3',
    meta: { requiresAuth: true, requiresRole: 'FormIQManager' },
    children: [
      { path: 'workflows', component: AdminWorkflowConfigPage },
      { path: 'formiq3', component: AdminFormIQ3Page },
    ],
  },
  {
    path: '/caseworker/review',
    component: CaseworkerReviewPage,
    meta: { requiresAuth: true, requiresRole: 'FormIQWorker' },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, _from, next) => {
  if (to.meta.requiresAuth && !authStore.isSessionValid()) {
    next('/login');
  } else if (to.meta.requiresRole && !authStore.hasRole(to.meta.requiresRole)) {
    next('/dashboard');
  } else {
    next();
  }
});

export default router;
